

















































import { Vue, Component } from 'vue-property-decorator';
import { userServe } from '@/api/installServer';
import { deepClone } from '@/util/deepClone';
import { UserModule } from '@/store/modules/user';
@Component({
  components: {},
})
export default class TreeUnit extends Vue {
  openFlag = true; // 控制树的显示隐藏
  openTreeFlag = false; // 控制节点展开收起
  currentData: Array<any> = []; // 组织机构树数据

  defaultChecked = []; // 默认选中的节点

  defaultProps: object = {
    children: 'child',
    label: 'name',
  };
  value = '否'; // 单选按钮绑定的值
  isNotStrictly = true; // 默认机构树父子不关联

  /**
   * desc： 控制组织树形图显示隐藏
   */
  toggleOpen() {
    this.openFlag = !this.openFlag;
    this.$emit('showTree', this.openFlag);
  }

  /**
   * desc： 控制组织树形图节点全部展开或收缩
   */
  changeTreeState() {
    this.openTreeFlag = !this.openTreeFlag;
    (this.$refs.treeRef as any).store._getAllNodes().forEach((val: any, i: number) => {
      if (this.openTreeFlag) {
        val.expanded = true;
      } else {
        val.expanded = false;
      }
    });
  }

  /**
   * desc： 获取选中节点的信息 调用手动指定节点的接口
   */
  handleTreeClick() {
    const nodeList = (this.$refs.treeRef as any).getCheckedNodes();
    const deptIds: any = [];
    const spaceIds: any = [];
    nodeList.forEach((item: any) => {
      if (item.type === '部门') {
        deptIds.push(item.id);
      }
      if (item.type === '空间') {
        spaceIds.push(item.id);
      }
    });
    userServe
      .manualOrgTree({ deptIds, spaceIds })
      .then((res: any) => {
        this.$emit('getNodeIds');
      })
      .catch((error: any) => {});
  }

  /**
   * desc： 递归 每条添加属性
   */
  getCallBack(data: any) {
    if (data.child.length > 0) {
      data.child.forEach((elem: any) => {
        this.getCallBack(elem);
      });
    }
    if (!data.valid) {
      data.disabled = true;
      if (data.child.length > 0) {
        data.child.forEach((elem: any) => {
          elem.disabled = true;
        });
      }
    }
  }

  /**
   * desc： 树形图刷新
   */
  refresh() {
    this.currentTreeUnitData();
  }

  /**
   * 树形图 获取手动选中的节点数据
   */
  getManualSpecifyOrg() {
    userServe
      .getManualSpecifyOrg({})
      .then((res: any) => {
        if (res.code === '200') {
          this.defaultChecked = res.data.deptIds.concat(res.data.spaceIds);
          // console.log(this.defaultChecked);
        }
      })
      .catch((error: any) => {});
  }

  /**
   * 树形图 当前用户的组织机构树
   */
  currentTreeUnitData() {
    // let res = {
    //   code : "200",
    //   msg : "成功",
    //   data : [
    //     {
    //       id : "250831f2d190416b9e2198486ce9c829",
    //       spaceId : "250831f2d190416b9e2198486ce9c829",
    //       valid : true,
    //       name : "市水务集团",
    //       type : "空间",
    //       child : [
    //         {
    //           id : "fc6d301bb1a03215ad9f6000e3617d7b",
    //           spaceId : "250831f2d190416b9e2198486ce9c829",
    //           valid : true,
    //           name : "部门3",
    //           type : "部门",
    //           child : [ ],
    //           pid : null
    //         },
    //         {
    //           id : "b8f69b4ce9fe26b462e3afb882718454",
    //           spaceId : "250831f2d190416b9e2198486ce9c829",
    //           valid : true,
    //           name : "部门1",
    //           type : "部门",
    //           child : [
    //             {
    //             id : "cc1a0d3e99fc0585268d70e7e0e65d61",
    //             spaceId : "250831f2d190416b9e2198486ce9c829",
    //             valid : true,
    //             name : "部门1-2",
    //             type : "部门",
    //             child : [
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e16",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-3",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //               {
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },{
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },{
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },{
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },{
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },{
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },{
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },{
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },{
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },{
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },{
    //                 id : "75540922d89fcbb6603afedfed045e17",
    //                 spaceId : "250831f2d190416b9e2198486ce9c829",
    //                 valid : true,
    //                 name : "部门1-1-2",
    //                 type : "部门",
    //                 child : [ ],
    //                 pid : "cc1a0d3e99fc0585268d70e7e0e65d61"
    //               },
    //             ],
    //             pid : "b8f69b4ce9fe26b462e3afb882718454"
    //             }
    //           ],
    //           pid : null
    //         },
    //         {
    //           id : "4817dff01d5264751c7b626a1d2fd762",
    //           spaceId : "250831f2d190416b9e2198486ce9c829",
    //           valid : true,
    //           name : "部门2",
    //           type : "部门",
    //           child : [
    //             {
    //               id : "38e47c8a5727777d93476d1485d1aa46",
    //               spaceId : "250831f2d190416b9e2198486ce9c829",
    //               valid : true,
    //               name : "部门2-2",
    //               type : "部门",
    //               child : [ ],
    //               pid : "4817dff01d5264751c7b626a1d2fd762"
    //             },
    //             {
    //               id : "bfa39728631b366c19f88e840c05dd81",
    //               spaceId : "250831f2d190416b9e2198486ce9c829",
    //               valid : true,
    //               name : "部门2-3",
    //               type : "部门",
    //               child : [ ],
    //               pid : "4817dff01d5264751c7b626a1d2fd762"
    //             }
    //           ],
    //           pid : null
    //         },
    //         {
    //           id : "47e7354f8d51c9a05a02aabb4be84066",
    //           spaceId : "250831f2d190416b9e2198486ce9c829",
    //           valid : true,
    //           name : "部门4",
    //           type : "部门",
    //           child : [ ],
    //           pid : null
    //         },
    //         {
    //           id : "5e35c1ba44354c2fb7a04972563df9d3",
    //           spaceId : "5e35c1ba44354c2fb7a04972563df9d3",
    //           valid : true,
    //           name : "杭州市水务集团排水分公司",
    //           type : "空间",
    //           child : [
    //             {
    //               id : "2f5db9304e114b1f9023635610cf0c29",
    //               spaceId : "2f5db9304e114b1f9023635610cf0c29",
    //               valid : true,
    //               name : "杭州市水务集团有限公司九溪水厂",
    //               type : "空间",
    //               child : [
    //                 {
    //                   id : "ee3c95d32b55cb2a433c58aa9dbcc45e",
    //                   spaceId : "2f5db9304e114b1f9023635610cf0c29",
    //                   valid : true,
    //                   name : "1111",
    //                   type : "部门",
    //                   child : [
    //                     {
    //                       id : "d932785421a191170f302a1df4216f1d",
    //                       spaceId : "2f5db9304e114b1f9023635610cf0c29",
    //                       valid : true,
    //                       name : "2222",
    //                       type : "部门",
    //                       child : [ ],
    //                       pid : "ee3c95d32b55cb2a433c58aa9dbcc45e"
    //                     }
    //                   ],
    //                   pid : null
    //                 }
    //               ],
    //               pid : "5e35c1ba44354c2fb7a04972563df9d3"
    //             }
    //           ],
    //           pid : "250831f2d190416b9e2198486ce9c829"
    //         },
    //         {
    //           id : "fb358c2199a34997977ab462c5a0749c",
    //           spaceId : "fb358c2199a34997977ab462c5a0749c",
    //           valid : true,
    //           name : "杭州市水务集团制水分公司",
    //           type : "空间",
    //           child : [
    //             {
    //               id : "2906b31d05f24f299ad5be623b8ed3de",
    //               spaceId : "2906b31d05f24f299ad5be623b8ed3de",
    //               valid : true,
    //               name : "市水务集团有限公司城西水处理分公司",
    //               type : "空间",
    //               child : [ ],
    //               pid : "fb358c2199a34997977ab462c5a0749c"
    //             },
    //             {
    //               id : "dbbab70763d44cdaa004c6efc28bd582",
    //               spaceId : "dbbab70763d44cdaa004c6efc28bd582",
    //               valid : true,
    //               name : "杭州市水务集团有限公司清泰水厂",
    //               type : "空间",
    //               child : [
    //                 {
    //                   id : "111d13c3c9204a2e8d1907f951cd2d01",
    //                   spaceId : "111d13c3c9204a2e8d1907f951cd2d01",
    //                   valid : true,
    //                   name : "银湖制水",
    //                   type : "空间",
    //                   child : [ ],
    //                   pid : "dbbab70763d44cdaa004c6efc28bd582"
    //                 }
    //               ],
    //               pid : "fb358c2199a34997977ab462c5a0749c"
    //             }
    //           ],
    //           pid : "250831f2d190416b9e2198486ce9c829"
    //         }
    //       ],
    //       pid : ""
    //     }
    //   ],
    //   success : true
    // }
    // if (res.code === '200') {
    //   this.currentData = deepClone(res.data);
    //   this.currentData.forEach((item: any) => {
    //     this.getCallBack(item);
    //   });
    // }
    userServe
      .getCurrentOrgTree({})
      .then((res: any) => {
        if (res.code === '200') {
          this.currentData = deepClone(res.data);
          this.currentData.forEach((item: any) => {
            this.getCallBack(item);
          });
        }
      })
      .catch((error: any) => {
        this.$message.error('初始化树形图数据失败!');
      });
  }

  // 获取单选组的值
  change(e: any) {
    if (e === '是') {
      this.isNotStrictly = false;
    } else {
      this.isNotStrictly = true;
    }
  }
  // 请求 树形图数据接口
  created() {
    this.currentTreeUnitData();
  }

  // 页面刷新保留上次手动指定的节点
  mounted() {
    if (UserModule.orgList.length === 0) {
      UserModule.getOrgInfo();
    }

    this.getManualSpecifyOrg();
  }

  clearNodes() {
    (this.$refs.treeRef as any).setCheckedKeys([]);
    this.handleTreeClick();
    this.$emit('getNodeIds');
  }
}
